import axios from "axios";

document.getElementById('poll-form').addEventListener('submit', function(event) {
    event.preventDefault();

    const formData = new FormData(this);
    axios.post(this.action, formData)
        .then(response => {
            // Сначала показываем сообщение
            alert(response.data.message);
            // После нажатия OK выполняем редирект
            if (response.data.redirect) {
                window.location.href = response.data.redirect;
            }
        })
        .catch(error => {
            if (error.response) {
                alert(error.response.data.error);
            } else {
                alert('Произошла ошибка. Пожалуйста, попробуйте снова.');
            }
        });
});